import React from "react";
import axiosInstance from "../../api/axiosConfig";

const TableSedesEmpresa = () => {
  const [sedes, setSedes] = React.useState([]);

  const fetchSedes = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axiosInstance.get("/api/empresa/sedes", {
        headers: { Authorization: token },
      });
      setSedes(res.data);
    } catch (error) {
      console.error("Error al obtener sedes:", error);
    }
  };

  React.useEffect(() => {
    fetchSedes();
  }, []);

  return (
    <div>
      <h2>Mis Sedes</h2>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#53676c", color: "white" }}>
            <th style={th}>Nombre</th>
            <th style={th}>Razón Social</th>
            <th style={th}>Dirección</th>
            <th style={th}>Teléfono</th>
            <th style={th}>Email</th>
            <th style={th}>Estado</th>
          </tr>
        </thead>
        <tbody>
          {sedes.length === 0 ? (
            <tr>
              <td colSpan={6} style={{ textAlign: "center", padding: "1rem" }}>
                No hay sedes registradas
              </td>
            </tr>
          ) : (
            sedes.map((sede) => (
              <tr key={sede.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={td}>{sede.name}</td>
                <td style={td}>{sede.reason_social}</td>
                <td style={td}>{sede.address}</td>
                <td style={td}>{sede.phone}</td>
                <td style={td}>{sede.email}</td>
                <td style={td}>{sede.status}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

const th = { padding: "12px 16px", textAlign: "left" };
const td = { padding: "10px 16px" };

export default TableSedesEmpresa;
